<template>
    <div v-if="isShow" :style="domStyle">
        <div style="width:100%;height:100%" v-html="svgInfo">

        </div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.monitor();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });

        // 获取svg文件地址
        this.loadSvgPath();
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            currentWidth : "100%",
            currentHeight : "100%",
            svgInfo: ""
        }
    },
    computed: {
        currentUrl(){
            return this.pictureUrl;
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.currentWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.currentHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：更新svg图片展示
        */
        updateImg(value){
            this.currentUrl = value;
        },
        /*
            参数：无
            作用：监听组件内部属性
        */
        monitor(){
            // 内部属性 控制svg路径展示变化
            Object.defineProperty(this,"Path",{
                set(value){
                    this.currentUrl = value;
                    this.$forceUpdate();
                },
                get(){
                    return this.currentUrl;
                }
            })
        },
        // 读取文件信息
        loadSvgInfo(name) {
            let xhr = new XMLHttpRequest(),
                okStatus = document.location.protocol === "file:" ? 0 : 200;
            xhr.open('GET', name, false);
            xhr.overrideMimeType("text/html;charset=utf-8");//默认为utf-8
            xhr.send(null);
            return xhr.status === okStatus ? xhr.responseText : null;
        },
        loadSvgPath() {
            // 去除第一个斜杠
            this.pictureUrl = this.pictureUrl.split("/");
            this.pictureUrl.shift();
            this.pictureUrl = this.pictureUrl.join("/");
            this.svgInfo = this.loadSvgInfo(window.location.href + this.pictureUrl);
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvSvgPic/fvSvgPic.vue